import React, { Component } from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import Button from '../../common/form/button';
import SPButton from '../../common/form/spButton';
import ConfirmarExclusaoModal from '../../common/components/confirmarExclusaoModal';

class EquipeMembros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      membros: [],
      usuarios: [],
      usuarioId: '',
      loading: false,
      excluirMembro: null,
    };
    this.carregar = this.carregar.bind(this);
    this.adicionar = this.adicionar.bind(this);
    this.solicitarRemocao = this.solicitarRemocao.bind(this);
    this.confirmarRemocao = this.confirmarRemocao.bind(this);
    this.cancelarRemocao = this.cancelarRemocao.bind(this);
  }

  componentDidMount() {
    this.carregar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.equipeId !== this.props.equipeId) {
      this.carregar();
    }
  }

  carregar() {
    const { equipeId } = this.props;
    if (!equipeId) return;

    this.setState({ loading: true });
    Promise.all([
      axiosInstance.get(`/manutencao/equipes/${equipeId}/membros`),
      axiosInstance.get('/manutencao/opcoes'),
    ])
      .then(([membrosResp, opcoesResp]) => {
        this.setState({
          membros: membrosResp.data || [],
          usuarios: opcoesResp.data.usuarios || [],
          loading: false,
        });
      })
      .catch(() => {
        toastr.error('Erro', 'Não foi possível carregar os membros da equipe.');
        this.setState({ loading: false });
      });
  }

  adicionar() {
    const { equipeId } = this.props;
    const { usuarioId } = this.state;
    if (!usuarioId) {
      toastr.warning('Atenção', 'Selecione um usuário.');
      return;
    }

    axiosInstance
      .post(`/manutencao/equipes/${equipeId}/membros`, { usuario_id: parseInt(usuarioId, 10) })
      .then(() => {
        toastr.success('Sucesso', 'Membro adicionado à equipe.');
        this.setState({ usuarioId: '' });
        this.carregar();
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível adicionar o membro.');
      });
  }

  solicitarRemocao(membro) {
    this.setState({ excluirMembro: membro });
  }

  confirmarRemocao() {
    const { equipeId } = this.props;
    const { excluirMembro } = this.state;
    if (!excluirMembro) return;

    axiosInstance
      .delete(`/manutencao/equipes/${equipeId}/membros/${excluirMembro.id}`)
      .then(() => {
        toastr.success('Sucesso', 'Membro removido da equipe.');
        this.setState({ excluirMembro: null });
        this.carregar();
      })
      .catch(() => toastr.error('Erro', 'Não foi possível remover o membro.'));
  }

  cancelarRemocao() {
    this.setState({ excluirMembro: null });
  }

  render() {
    const { equipeNome } = this.props;
    const { membros, usuarios, usuarioId, loading, excluirMembro } = this.state;
    const idsMembros = membros.map(m => m.usuario_id);

    return (
      <div className="simple-cad-form-premium equipe-membros-premium" style={{ marginTop: 20 }}>
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-user-friends" /> Membros — {equipeNome}
              </h4>
              <p>Associe os técnicos que fazem parte desta equipe de manutenção.</p>
            </div>
            <div className="simple-cad-premium-body">
              <div className="equipe-membros-add-bar">
                <div className="form-group form-group-sm equipe-membros-add-field">
                  <label className="label-gt">Adicionar usuário</label>
                  <select
                    className="form-control"
                    value={usuarioId}
                    onChange={e => this.setState({ usuarioId: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {usuarios
                      .filter(u => !idsMembros.includes(u.id))
                      .map(u => (
                        <option key={u.id} value={u.id}>
                          {u.nome}
                        </option>
                      ))}
                  </select>
                </div>
                <Button
                  type="button"
                  className="primary equipe-membros-add-btn"
                  icon="plus"
                  label="Adicionar"
                  onClick={this.adicionar}
                />
              </div>

              <div className="equipe-membros-lista-header">
                <h5>
                  <i className="fa fa-users" /> Técnicos vinculados
                  {!loading && membros.length > 0 && (
                    <span className="equipe-membros-lista-count">{membros.length}</span>
                  )}
                </h5>
              </div>

              {loading ? (
                <div className="equipe-membros-loading">
                  <i className="fa fa-spinner fa-spin" /> Carregando membros...
                </div>
              ) : membros.length === 0 ? (
                <div className="equipe-membros-empty">
                  <div className="equipe-membros-empty-icon">
                    <i className="fa fa-user-plus" />
                  </div>
                  <strong>Nenhum membro associado</strong>
                  <p>Selecione um usuário acima e clique em Adicionar para vincular à equipe.</p>
                </div>
              ) : (
                <div className="equipe-membros-lista">
                  {membros.map(m => (
                    <div className="equipe-membro-item" key={m.id}>
                      <div className="equipe-membro-item-ident">
                        <div className="equipe-membro-item-icon">
                          <i className="fa fa-user" />
                        </div>
                        <div className="equipe-membro-item-info">
                          <strong>{m.nome_usuario}</strong>
                          <span>Membro ativo</span>
                        </div>
                      </div>
                      <div className="os-actions-group">
                        <SPButton
                          type="button"
                          className="danger btn-sm"
                          icon="trash-alt"
                          data-title="Remover"
                          onClick={() => this.solicitarRemocao(m)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <ConfirmarExclusaoModal
          show={!!excluirMembro}
          titulo="Remover membro da equipe"
          mensagem="O vínculo deste técnico com a equipe será encerrado."
          itemNome={excluirMembro ? excluirMembro.nome_usuario : ''}
          confirmarLabel="Remover"
          onConfirm={this.confirmarRemocao}
          onCancel={this.cancelarRemocao}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  equipeId: state.manutencaoEquipe.selectedEquipe && state.manutencaoEquipe.selectedEquipe.id,
  equipeNome: state.manutencaoEquipe.selectedEquipe && state.manutencaoEquipe.selectedEquipe.nome,
});

export default connect(mapStateToProps)(EquipeMembros);
